const SECRETS = {
  // SERVER: 'http://localhost:7000',
  SERVER: 'https://api57.caebes.com:8000',
  // SOCKETURL: 'http://localhost:9500',
  SOCKETURL: 'https://api57.caebes.com:9500',
};

export default SECRETS;
